import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {BaseRecordTableItemComponent} from './record-table-items/base-record-table-item/base-record-table-item.component';
import {NumberRecordTableItemComponent} from './record-table-items/number-record-table-item/number-record-table-item.component';
import {TextRecordTableItemComponent} from './record-table-items/text-record-table-item/text-record-table-item.component';
import {SwitchMultiCasePipe} from '../../../shared/pipes/switch-multi-case.pipe';
import {DateRecordTableItemComponent} from './record-table-items/table-dates/date-record-table-item/date-record-table-item.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {ModalRecordTableItemComponent} from './record-table-items/modal-record-table-item/modal-record-table-item.component';
import {ClickOutsideDirective} from '../../../shared/directives/click-outside.directive';
import {
  BooleanRecordTableItemComponent
} from './record-table-items/boolean-record-table-item/boolean-record-table-item.component';
import {
  ColorRecordTableItemComponent
} from "./record-table-items/color-record-table-item/color-record-table-item.component";
import {
  ChipsRecordTableItemComponent
} from './record-table-items/chips-record-table-item/chips-record-table-item.component';
import {
  ColorRecordTableModalComponent
} from "./record-table-items/color-record-table-item/color-record-table-modal/color-record-table-modal.component";
import {PlanFactItemComponent} from './record-table-items/plan-fact-item/plan-fact-item.component';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {DynamicWidthDirective} from "../../../shared/directives/dynamic-width.directive";
import {
  MonthYearRecordTableItemComponent
} from "./record-table-items/table-dates/month-year-record-table-item/month-year-record-table-item.component";
import {
  YearRecordTableItemComponent
} from "./record-table-items/table-dates/year-record-table-item/year-record-table-item.component";
import {
  RecordTableItemsListComponent
} from './record-table-items/record-table-items-list/record-table-items-list.component';
import {DateInputDirective} from "../../../shared/directives/date-input.directive";
import {MatBadge} from "@angular/material/badge";
import {
  TimeRecordTableItemComponent
} from "./record-table-items/time-record-table-item/time-record-table-item.component";
import {MatTimepicker, MatTimepickerInput, MatTimepickerToggle} from "@angular/material/timepicker";
import {
  DynamicSingleSelectTableItemComponent
} from "./record-table-items/table-selects/dynamic-single-select-table-item/dynamic-single-select-table-item.component";
import {
  DynamicMultiSelectTableItemComponent
} from "./record-table-items/table-selects/dynamic-multi-select-table-item/dynamic-multi-select-table-item.component";
import {
  MultiSelectTableItemComponent
} from "./record-table-items/table-selects/multi-select-table-item/multi-select-table-item.component";
import {
  SingleSelectTableItemComponent
} from "./record-table-items/table-selects/single-select-table-item/single-select-table-item.component";
import {PhotoTableItemComponent} from "./record-table-items/photo-table-item/photo-table-item.component";
import {RussianDatePipe} from "../../../shared/pipes/russian-date.pipe";
import {MatCheckbox} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";
import {MatChipGrid, MatChipInput, MatChipRow} from "@angular/material/chips";
import {MatIcon} from "@angular/material/icon";
import {MatInput, MatSuffix} from "@angular/material/input";
import {MatMiniFabButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {MatOption, MatSelect} from "@angular/material/select";

@NgModule({
  declarations: [
    BaseRecordTableItemComponent,
    NumberRecordTableItemComponent,
    TextRecordTableItemComponent,
    DateRecordTableItemComponent,
    TimeRecordTableItemComponent,
    SingleSelectTableItemComponent,
    ModalRecordTableItemComponent,
    BooleanRecordTableItemComponent,
    ColorRecordTableItemComponent,
    ColorRecordTableModalComponent,
    ChipsRecordTableItemComponent,
    MultiSelectTableItemComponent,
    PlanFactItemComponent,
    MonthYearRecordTableItemComponent,
    YearRecordTableItemComponent,
    RecordTableItemsListComponent,
    DynamicMultiSelectTableItemComponent,
    DynamicSingleSelectTableItemComponent,
    PhotoTableItemComponent
  ],
  imports: [
    CommonModule,
    SwitchMultiCasePipe,
    MatDatepickerModule,
    ScrollingModule,
    ClickOutsideDirective,
    DynamicWidthDirective,
    DateInputDirective,
    MatBadge,
    MatTimepickerToggle,
    MatTimepickerInput,
    MatTimepicker,
    RussianDatePipe,
    MatCheckbox,
    FormsModule,
    MatChipGrid,
    MatChipRow,
    MatIcon,
    MatChipInput,
    MatInput,
    MatMiniFabButton,
    MatTooltip,
    MatSuffix,
    MatSelect,
    MatOption
  ],
  exports: [
    NumberRecordTableItemComponent,
    TextRecordTableItemComponent,
    DateRecordTableItemComponent,
    TimeRecordTableItemComponent,
    SingleSelectTableItemComponent,
    ModalRecordTableItemComponent,
    ColorRecordTableModalComponent,
    BooleanRecordTableItemComponent,
    ChipsRecordTableItemComponent,
    MultiSelectTableItemComponent,
    PlanFactItemComponent,
    MonthYearRecordTableItemComponent,
    YearRecordTableItemComponent,
    RecordTableItemsListComponent,
    DynamicMultiSelectTableItemComponent,
    DynamicSingleSelectTableItemComponent,
    PhotoTableItemComponent
  ],
})
export class RecordsTableModule { }
